jQuery ->
  $('.datatable').dataTable
    bInfo: false
    paging: false
    searching: false
